import styled from "styled-components";

export const Container = styled.div``;

export const ItemGroup = styled.fieldset`
    border: 1px solid #DEDEDE;
    border-radius: 8px;

    & legend {
      display: flex;
      align-items: center;
    }
`;

export const IncludedItems = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

export const IncludedItem = styled.div`
    display: flex;
    color: #252525;
    align-items: center;
    justify-content: space-between;
`;

export const ItemActions = styled.div` 
    display: flex;
    gap: 1px;
`;

export const ItemFields = styled.div`
    display: flex;
    gap: 10px;
`;

export const ButtonContainer = styled.div`
    padding: 10px 0 10px 0;
`;
